// extracted by mini-css-extract-plugin
export default {"noDataNotification":"CoacheeNotesDrawer_noDataNotification__ydr5P"};